import { useSelector } from 'react-redux';

import Button from 'components/Button';
import { ENUM_TYPE_REPORT_STATUS } from 'constants/enum';

const Header = ({ form }) => {
  const { me } = useSelector((state) => state.auth);
  const { childrenDetail } = useSelector((state) => state.children);

  const handleSubmit = async (status) => {
    await form.setFieldValue('status', status);
    await form.handleSubmit();
  };

  return (
    <div className="flex justify-between items-center w-full pt-3 pb-5">
      <p className="font-bold text-[22px]">レポート詳細登録</p>
      <Button
        onClick={() => {
          if (form.values.status !== ENUM_TYPE_REPORT_STATUS.FINISH) {
            handleSubmit(ENUM_TYPE_REPORT_STATUS.FINISH);
          }
        }}
        type="button"
        color={`${form.values.status !== ENUM_TYPE_REPORT_STATUS.FINISH ? 'primary' : 'outline'}`}
        text="ユーザに詳細レポートを送信"
        className={`!rounded-full !gap-4 px-7 ${form.values.status === ENUM_TYPE_REPORT_STATUS.FINISH ? '!bg-gray-651 !text-white cursor-not-allowed' : ''}`}
        icon={<img src={require('assets/resources/SendIconWhite.svg').default} alt="plus icon" width={18} height={18} />}
      />
    </div>
  );
};

export default Header;
